export default {
  default: {
    noAvailableComparables: 'No Available Comparables',
  },
}
